import { render, staticRenderFns } from "./activityApprovalOperate.vue?vue&type=template&id=268f6056"
import script from "./activityApprovalOperate.vue?vue&type=script&lang=js"
export * from "./activityApprovalOperate.vue?vue&type=script&lang=js"
import style0 from "./activityApprovalOperate.vue?vue&type=style&index=0&id=268f6056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports